<template>
  <div class="common-container">
    <div class="detail">
      <div class="d-left">
        <classify :name="name" :classify-id="classifyId"/>
      </div>
      <div class="d-right">
        <div class="header">
          <div class="h-left">产品详情</div>
          <div class="h-right" v-if="!source" @click="$router.go(-1)">
            <span>返回列表</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="main">
          <div class="info">
            <div class="mi-left">
              <product-banner :images="detail.banner"/>
            </div>
            <div class="mi-right">
              <div class="name">{{ detail.name }}</div>
              <div class="price-gift-promise">
                <div class="pgp price">
                  <div class="title">价格</div>
                  <div class="value">{{ price }}</div>
                </div>
                <div class="pgp gift">
                  <div class="title">赠品</div>
                  <div class="value">{{ detail.gift }}</div>
                </div>
                <div class="pgp promise">
                  <div class="title">承诺</div>
                  <div class="value" v-if="detail.promiseList && detail.promiseList.length > 0">
                    <div class="promise-item" v-for="(v,i) in detail.promiseList" :key="i">
                      <el-image :src="v.image"></el-image>
                      <span>{{ v.name }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="specs-sku" v-if="detail.specsList && detail.specsList.length > 0">
                <div class="sk-item" v-for="(v,i) in detail.specsList" :key="i">
                  <div class="s-name">{{ v.name }}</div>
                  <div class="children" :class="v.show?'show':''" v-if="v.children && v.children.length > 0">
                    <div class="k-name" :class="selection[i] && selection[i].specsId === m.specsId?'act':''"
                         v-for="(m,n) in v.children"
                         :key="n" @click="select(i,m)">{{ m.name }}
                    </div>
                  </div>
                  <i :class="v.show?'el-icon-arrow-down':'el-icon-arrow-right'"
                     :style="v.children.length > 5?'opacity:1':''"
                     @click="showAllItem(v)"></i>
                </div>
              </div>
              <div class="phone-btn" @click="showPhone = true">
                <el-image :src="require('@/assets/product/detail/icon.png')"></el-image>
                <div class="value">{{ showPhone ? websiteConfig.productPhone : '显示电话号码' }}</div>
              </div>
            </div>
          </div>
          <div class="desc">
            <el-tabs v-model="descActiveIndex">
              <el-tab-pane :label="v.title" :name="v.descId" v-for="(v,i) in detail.descList" :key="i">
                <div class="content" v-html="v.content"></div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Classify from '../components/Classify.vue'
import ProductBanner from './components/ProductBanner.vue'
import {toTreeData} from "@/utils/common";
import {getWebsiteConfig} from "@/utils/website-config";

export default {
  name: "ProductDetail",
  components: {
    Classify,
    ProductBanner
  },
  data() {
    return {
      detail: {},
      name: '',
      classifyId: null,
      descActiveIndex: '',
      selection: [],
      showPhone: false,
      source: null
    }
  },
  computed: {
    price() {
      const selectName = this.selection.map(d => d.name).join('')
      let tempSku = []
      if (this.detail.skuList && this.detail.skuList.length > 0) {
        tempSku = this.detail.skuList.filter(d => {
          if (d['options'].join('') === selectName) return d
        })
      }
      if (tempSku.length > 0) {
        return tempSku[0].price
      }
      return ''
    },
    websiteConfig() {
      return getWebsiteConfig()
    }
  },
  watch: {
    '$route.query': {
      immediate: true,
      deep: true,
      handler({productId, name, classifyId, source}) {
        this.source = source
        this.name = name
        this.classifyId = classifyId
        this.$request.get('/Product/detail', {
          params: {
            productId
          }
        }).then(res => {
          if (res.code === 0) {
            this.detail = {
              ...res.data,
              descList: res.data.descList ? res.data.descList.map(d => {
                d['descId'] = `${d['descId']}`
                return d
              }) : [],
              specsList: toTreeData({
                data: res.data.specsList ? res.data.specsList : [],
                idField: 'specsId',
                parentIdField: 'parentId'
              }).map(d => {
                d['show'] = false
                return d
              })
            }
            this.descActiveIndex = this.detail.descList[0].descId
            for (let i = 0; i < this.detail.specsList.length; i++) {
              this.$set(this.selection, i, this.detail.specsList[i].children[0])
            }
          }
        })
      }
    }
  },
  methods: {
    /**
     * 选择
     */
    select(parentIndex, child) {
      this.$set(this.selection, parentIndex, child)
    },
    /**
     * 展示全部列
     * @param parent
     */
    showAllItem(parent) {
      parent.show = !parent.show
    }
  }
}
</script>

<style scoped lang="scss">
.detail {
  width: 1200px;
  padding: 30px 0 60px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .d-right {
    width: 940px;
    border-radius: 8px;
    overflow: hidden;
    height: fit-content;

    .header {
      width: 100%;
      height: 54px;
      background-color: #1464FF;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 0 24px;
      color: #FFFFFF;
      font-weight: bold;

      .h-left {
        font-size: 16px;
      }

      .h-right {
        font-size: 14px;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .main {
      width: 100%;
      background-color: #FFFFFF;
      padding: 25px;
      display: flex;
      flex-direction: column;

      .info {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;

        .mi-left {
          width: 290px;
        }

        .mi-right {
          width: 562px;
          display: flex;
          flex-direction: column;

          .name {
            color: #000000;
            font-size: 24px;
            font-weight: bold;
          }

          .price-gift-promise {
            width: 100%;
            border: 1px solid #D7D7D7;
            border-radius: 4px;
            background-color: #F4F6FA;
            margin-top: 12px;
            padding: 16px 20px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .pgp {
              display: flex;
              flex-direction: row;
              align-items: center;
              margin-top: 10px;

              &.price {
                margin-top: 0;

                .value {
                  font-size: 18px;
                }
              }

              &.gift .value {
                font-size: 14px;
              }

              &.promise {
                align-items: flex-start;

                .value {
                  display: flex;
                  flex-wrap: wrap;

                  .promise-item {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    margin-right: 12px;
                    line-height: 20px;

                    .el-image {
                      width: 18px;
                      height: 18px;
                    }

                    span {
                      color: #6C6C6C;
                      font-size: 14px;
                    }
                  }
                }
              }

              .title {
                color: #6C6C6C;
                font-size: 14px;
                margin-right: 20px;
              }

              .value {
                color: #FF3E4A;
                font-weight: bold;
                flex: 1;
                width: 0;
              }
            }
          }

          .specs-sku {
            display: flex;
            flex-direction: column;
            margin-top: 25px;

            .sk-item {
              display: flex;
              flex-direction: row;
              align-items: flex-start;
              justify-content: space-between;
              margin-bottom: 20px;

              &:last-child {
                margin-bottom: 0;
              }

              .s-name {
                color: #6C6C6C;
                font-size: 14px;
                line-height: 28px;
              }

              .children {
                flex: 1;
                width: 0;
                margin: 0 30px;
                display: grid;
                grid-template-columns: repeat(5, 1fr);
                gap: 12px;
                height: 28px;
                overflow: hidden;

                &.show {
                  height: auto;
                }

                .k-name {
                  color: #6C6C6C;
                  font-size: 14px;
                  line-height: 28px;
                  width: 76px;
                  height: 28px;
                  border: 1px solid #D7D7D7;
                  border-radius: 4px;
                  text-align: center;
                  cursor: pointer;

                  &.act {
                    background-color: #1464FF;
                    border-color: #1464FF;
                    color: #FFFFFF;
                  }
                }
              }

              i {
                line-height: 28px;
                cursor: pointer;
                opacity: 0;
              }
            }
          }

          .phone-btn {
            margin-top: 40px;
            width: 194px;
            height: 48px;
            border-radius: 4px;
            background-color: #1464FF;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            .el-image {
              width: 20px;
              height: 20px;
              margin-right: 15px;
            }

            .value {
              font-size: 14px;
              font-weight: bold;
              color: #FFFFFF;
            }
          }
        }
      }

      .desc {
        padding: 40px 0 20px 0;

        ::v-deep {
          .content img {
            max-width: 100%;
          }

          .el-tabs__active-bar {
            background-color: #1464FF;
            height: 4px;
          }

          .el-tabs__nav-wrap::after {
            background-color: #D7D7D7;
          }

          .el-tabs__item {
            color: #6C6C6C;
            font-size: 16px;
            font-weight: bold;

            &.is-active {
              color: #2D2D2D;
            }

            &:hover {
              color: unset;
            }
          }
        }
      }
    }
  }
}
</style>